// PublicRoute.js
import { Navigate, useLocation } from "react-router-dom";
import { safeNextPath } from "../utils/postLoginRedirect";

const PublicRoute = ({ children}) => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  // If token exists, redirect to dashboard — or, for an already-signed-in
  // creator following an email deep link (?next=), straight to that page.
  if (token) {
    const role = localStorage.getItem("role");
    const next = safeNextPath(location.search);
    if (next && role === "Creator") {
      return <Navigate to={next} replace />;
    }
    return (
      <Navigate
        to={role === "Creator" ? "/mainlayout/creator-dashboard" : "/mainlayout/dashboard"}
        replace
      />
    );
  }

  // Otherwise, show the public (login) page
  return children;
};

export default PublicRoute;
